import React from 'react';
import { IoLockClosedSharp } from 'react-icons/io5';
import Spinner from '../../Spinner';

const LockScreenSimple = ({ isLocked, isLoading, title, description, fullScreen = true }) => {
  if (!isLocked && !isLoading) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        padding: 20,
        right: 0,
        left: 0,
        backgroundColor: "rgb(0 0 0 / 81%)",
        height: "100vh",
        zIndex: 1000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "black",
      }}
    >
      {isLoading ? (
        <Spinner size={40} type={2} color="white" />
      ) : (
        <div style={{
          textAlign: 'center',
          color: 'white',
          maxWidth: '500px',
          padding: '30px',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          boxShadow: '0 0 20px rgba(0,0,0,0.3)',
          backdropFilter: 'blur(4px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <IoLockClosedSharp size={70} style={{ marginBottom: 20 }} />
          <h2 style={{ fontSize: '2rem', marginBottom: 10, color:'white' }}>{title || 'Pantalla bloqueada'}</h2>
          <p style={{ fontSize: '1.1rem', color: '#e0e0e0' }}>
            {description || 'Esta sección está bloqueada por seguridad. Contacta al administrador si necesitas acceso.'}
          </p>
        </div>
      )}
    </div>
  );
};

export default LockScreenSimple;
